import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  hover = true
}: CardProps) {
  return <div className={`bg-white border border-slate-200 p-6 sm:p-8 rounded-sm ${hover ? 'transition-all duration-300 hover:shadow-lg hover:border-slate-300 hover:-translate-y-1' : ''} ${className}`} data-id="element-136">
      {children}
    </div>;
}